<script setup lang="ts">
import { isClient } from '@vueuse/core'
import { trackingParamsReverseMap } from '../../services/trackingParams'

const { portal, path, border } = defineProps<{
  portal: string
  path: string
  border?: string
}>()

const frame = ref<any>()
const storyblokApi = useStoryblokApiV2()
const data = await storyblokApi.getStory({ by_uuid: portal }) as { url: string }
const config = useRuntimeConfig()
const borderClass = computed(() => {
  return border ? `border rounded-xl ${border}` : null
})

function onMessage({ message }: { message: Record<string, string> }) {
  if (message.event === 'updateFullPath')
    history.pushState(null, '', message.fullPath)
}

const base = (() => {
  if (data.url) {
    const [prod, test] = data.url.split(',')
    return config.public.storyblokVersion === 'draft' ? test : prod
  }
  return ''
})()

const src = new URL(path, base)

if (isClient) {
  const trackingParams = useCookie('EOTracking')
  const query = useRoute().query

  if (query) {
    for (const [name, value] of Object.entries(query)) {
      if (isArray(value))
        value.forEach(value => src.searchParams.set(name, value || ''))
      else
        src.searchParams.set(name, value || '')
    }
  }

  if (trackingParams.value) {
    for (const [name, value] of Object.entries(trackingParams.value))
      if (value) src.searchParams.set(trackingParamsReverseMap.get(name), value)
  }
}

useEventListener(window, 'message', (event) => {
  const data = event?.data || {}
  const { type } = data

  if (type === 'routeChange') frame?.value?.scrollIntoView({ behavior: 'smooth' })
})
</script>

<template>
  <div ref="frame" class="pt-9 pb-22" :class="borderClass">
    <ClientOnly>
      <iframe v-resize="{ onMessage }" :src="src.href" width="100%" frameborder="0" class="mx-auto max-w-[1160px]" />
    </ClientOnly>
  </div>
</template>
